import { isAxiosError } from 'axios';
import { showAccessDeniedToast } from './toast-utils';

export const checkIsAccessDeniedError = (error: unknown) => {
  if (!error) return false;

  if (isAxiosError(error) || (typeof error === 'object' && 'status' in error)) {
    return error.status === 403;
  }

  return false;
};

export const checkIsConflictError = (error: unknown) => {
  if (!error) return false;

  if (isAxiosError(error) && error.response?.status === 409) {
    return true;
  }

  return false;
};

/**
 *
 * @param error - The error to handle
 * @param onError - The callback function to call if the error is not a 403
 */
export const errorHandler = (
  error: unknown,
  onError?: (error: unknown) => void,
) => {
  if (checkIsAccessDeniedError(error)) {
    showAccessDeniedToast();
  } else {
    onError?.(error);
  }
};
